// Copyright (c) 2022 WiseTime. All rights reserved.

import { EMPTY, Observable, of } from "rxjs"
import { Action } from "redux"
import { catchError, filter, mergeMap } from "rxjs/operators"
import { t } from "@lingui/macro"
import { create } from "@bufbuild/protobuf"
import * as Actions from "../actions"
import { showSnackBar } from "../../snackbar/actions"
import { executorMutation, Init, timelineService } from "../../../app/rpc"
import {
  CancelPostTimeRequestSchema,
  CancelPostTimeResponse,
} from "../../../generated/wisetime/user/timeline/v4/timeline_pb"

type CancelPostTimeRpc = (request: Init<typeof CancelPostTimeRequestSchema>) => Observable<CancelPostTimeResponse>

export const cancelPostTime = (cancelPostRpc: CancelPostTimeRpc) =>
  (action$: Observable<Action>): Observable<Action> =>
    action$.pipe(
      filter(Actions.cancelPostTime.match),
      mergeMap(action => cancelPostRpc(action.payload)
        .pipe(
          mergeMap(_ => EMPTY),
          catchError(_ => (
            of(showSnackBar({
              message: t({ id: "msg_cancel_post_time_failed", message: "Unable to cancel post time. Please try again in a couple of minutes. If the error persists, please contact support@wisetime.com." }),
              messageType: "ERROR",
            }))
          )),
        )
      ),
    )

const cancelPostRpc = (request: Init<typeof CancelPostTimeRequestSchema>): Observable<CancelPostTimeResponse> =>
  executorMutation(() => timelineService.cancelPostTime(create(CancelPostTimeRequestSchema, request)))

export default cancelPostTime(cancelPostRpc)
